import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import { takeLinkTokenFromUrl } from "./utils/tb/publicLinkToken"

// Antes de tudo: o token do link público (?k=) sai da URL antes que os
// trackers (GA4 / Meta Pixel) ou o roteador leiam o endereço.
takeLinkTokenFromUrl()

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(<App />)
